/* 设备故障修复 */

import {action} from 'mobx';
import {deviceRepair} from '@/services/Home';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import {message} from 'antd';
import UserStore from '@/stores/user';

class RepairStore {
  
  @action async deviceRepair(cid?: string) {
    
    const ids = cid ?
      DeviceStore.DeviceOperation.RebootStore.selectedId(cid) :
      DeviceStore.DeviceOperation.RebootStore.selectedIds
    
    const [error] = await deviceRepair({
      ids:  R.join(',', ids),
      groupId: UserStore.GroupStore.activeGroupId
    });
    
    if(error) return false;
    
    message.success('操作成功')
  
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
  
    return true
    
  }
  
}

export default RepairStore;
